import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { GetHealthCareProvidersArgs } from "../schemas";

const getHealthCareProvidersQueryKey = (args: GetHealthCareProvidersArgs) =>
  ["getHealthCareProviders", args.health_care_organization_id] as const;

export const useGetHealthCareProviders = (args: GetHealthCareProvidersArgs) => {
  const client = useApiClient();

  return useQuery(getHealthCareProvidersQueryKey(args), () => client.getHealthCareProviders(args));
};
